"use strict";

angular.module("diceApp").component("expandButton", {
  bindings: {
    isOpen: "<"
  },
  templateUrl: "es6/base/expand.button.html",
  controllerAs: "expandButtonController"
});
